import type { Resource } from '../../';
export const forms_error_minLength: Resource = {"default":"The {name} field must be at least {length} characters long."};
